import { forEach } from "lodash";

/**
 * This module is used to load html which can't be loaded otherwise by webpack
 * Webpack is uncapable of loading a partial html of a ng-include:
 * <ng-include src="'path/to/partial.html'"></<ng-include>
 * In order to do so, we're using $templaceCache to load the partial through a require
 * then we're using the templateCache ID to use the partial in angularjs
 */
class TemplateRun {
    public static $inject: string[] = [
        "$templateCache"
    ];
    private static PARTIALS: {} = {
        "loki/advanced-search/": [
            "organizations.advanced",
            "sales.advanced",
            "items.advanced"
        ],
        "shared/sort-menu/partials/": [
            "search.sort-menu",
            "future-items.sort-menu",
            "past-items.sort-menu",
            "sort-items.sort-menu"
        ],
        "core/multiple-select/": [
            "ms-toolbar-items",
            "ms-toolbar-online-items"
        ],
        "shared/media-editor/partials/": [
            "tone.sidenav"
        ],
        "sales/edit/add-item/": [
            "import-media-summary",
            "import-passerelle-summary",
            "import-sale-items-summary",
            "import-sale-result-summary"
        ],
        "online-containers/edit/add-item/": [
            "import-online-media-summary",
            "import-online-passerelle-summary"
        ],
        "online-containers/edit/link-payment-dialog/": [
            "create",
            "update"
        ]
    };

    constructor (
        $templateCache
    ) {
        forEach(TemplateRun.PARTIALS, (partials: string[], partialPath: string) => {
            partials.forEach(partial => {
                $templateCache.put(partial, require(`../${partialPath + partial}.html`));
            });
        });
    }
}

angular.module("thor.template", [])
    .run(TemplateRun);
